/**
 * src/lib/observability/perfThresholds.js — Latency classification for traces.
 *
 * Used by nav_trace + fetch_trace to tag events with severity so slow routes
 * and queries become filterable post-hoc in app_error_logs.
 */

export const PERF_THRESHOLDS = {
  route: { warning: 1000, critical: 2500 },
  query: { warning: 800, critical: 5000 },
};

export function classifyLatency(ms, kind = 'route') {
  const t = PERF_THRESHOLDS[kind];
  if (!t) return 'ok';
  if (ms > t.critical) return 'critical';
  if (ms > t.warning) return 'warning';
  return 'ok';
}
